"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const hiddenGems = [{
  title: "Azure Grotto",
  location: "Capri Coast",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553131/img/hidden_gem_grotto.png"
}, {
  title: "Emerald Valley",
  location: "Highlands",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553131/img/hidden_gem_valley.png"
}, {
  title: "Crimson Spire",
  location: "Desert Canyon",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553131/img/hidden_gem_spire.png"
}, {
  title: "Silent Monastery",
  location: "Cloud Peaks",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553131/img/hidden_gem_monastery.png"
}, {
  title: "Crystal Lagoon",
  location: "Tropical Islet",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553131/img/hidden_gem_lagoon.png"
}, {
  title: "Golden Dunes",
  location: "Sahara Edge",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553131/img/hidden_gem_dunes.png"
}, {
  title: "Mistfall Bridge",
  location: "Rainforest Deep",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553131/img/hidden_gem_bridge.png"
}];
export default function DiscoverHiddenGemsGallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="discover-hidden-gems-gallery" className="bg-primary py-32 overflow-hidden relative" ref={ref}>
      <div className={cn("container mx-auto px-4 mb-16 text-center transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <h2 className="text-4xl md:text-5xl font-bold text-primary-foreground inline-block relative pb-2">Discover Hidden Gems</h2>
        <p className="mt-6 text-primary-foreground/80 max-w-2xl mx-auto text-lg">
          Explore our curated collection of breathtaking destinations that remain
          untouched and waiting to be explored.
        </p>
      </div>

      <div className={cn("w-full transition-opacity duration-1000 delay-300", isVisible ? "opacity-100" : "opacity-0")}>
        <Carousel opts={{
        align: "center",
        loop: true
      }} className="w-full">
          <CarouselContent className="-ml-4">
            {hiddenGems.map((gem, i) => <CarouselItem key={i} data-index={i} className="pl-4 basis-[350px] md:basis-[350px]">
                <div className="relative group h-[450px] w-full overflow-hidden rounded-[8px] cursor-pointer">
                  <img src={gem.image} alt={gem.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <div className="absolute inset-0 bg-primary/40 transition-all duration-500 group-hover:bg-primary/10"></div>
                  
                  <div className="absolute inset-0 p-6 flex flex-col justify-end opacity-90 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                      <h3 className="text-2xl font-bold text-white mb-1 drop-shadow-md">
                        {gem.title}
                      </h3>
                      <p className="text-white/90 font-medium flex items-center gap-2 drop-shadow-sm">
                        {gem.location}
                      </p>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          
          <div className="hidden md:block">
            <CarouselPrevious className="left-8 h-12 w-12 border-2 border-white bg-transparent text-white hover:bg-white hover:text-primary hover:border-white transition-colors" />
            <CarouselNext className="right-8 h-12 w-12 border-2 border-white bg-transparent text-white hover:bg-white hover:text-primary hover:border-white transition-colors" />
          </div>
        </Carousel>
      </div>

      <div className={cn("mt-16 text-center transition-all duration-700 delay-500 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <Button asChild variant="outline" size="lg" className="border-2 border-white bg-transparent text-white hover:bg-white hover:text-primary px-8 py-6 text-lg font-semibold rounded-md transition-all duration-300">
          <Link to="/WebsitePagesPage">
            View All Collections
            <ArrowRight className="ml-2 h-5 w-5" />
          </Link>
        </Button>
      </div>
    </section>;
}